export default __webpack_public_path__ + "1a194e57dba8470e95c8bfe44b2f5279.png";